import React, { useContext, useEffect } from 'react';
import { history, useParams } from 'umi';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import CommonPageRender from '@/pages/benchmark/components/CommonPageRender/index';
import { PAGE_CONFIG_API } from '@/pages/benchmark/_config/constant';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId, isValidMetric } from '@/pages/benchmark/utils/utils';
import { pageViewLog } from '@/pages/benchmark/services/benchmark';

const MetricDetail = () => {
  const { frameType, metricConfig } = useContext(LayoutContext);
  const { metric } = useParams<{ metric: string; }>();
  const {metric: metricKey}=metricConfig?.[metric] || {};

  useEffect(() => {
    // 如果指标配置为空return
    if (JSON.stringify(metricConfig) === '{}') return;
    // 指标下架、匹配不到配置的指标或指标包含其他值，返回到搜索页面
    if (!(isValidMetric(metricKey, metric, metricConfig, ['tips']))) {
      history.replace(`/benchmark/${frameType}/explore`);
      return;
    }

    // 页面访问统计量打点
    const params = {
      logType: 'buttonLog',
      openId: '',
      buttonLog: {
        source: 1,
        buttonId: "800103001",
        extInfo: metric,
        pageId: "800103",
        uidType: '', // 基准打点不包含uidType
        typeId: getLogTypeId(frameType),
      }
    };
    pageViewLog(params).then(()=>{}).catch((e)=>{console.log(e)});
  }, [frameType, metric, metricConfig, metricKey]);

  const pageMap = {
    pcconsole: PC_PAGE_CONFIG,
    mobile: MOBILE_PAGE_CONFIG
  };

  return (
    <>
      <CommonPageRender
        reqParams={'/explore/metricTips'}
        pageConfigInit={pageMap?.[frameType]}
        api={PAGE_CONFIG_API}
      />
    </>
  );
};

export default MetricDetail;
